import { render, staticRenderFns } from "./AirplaneSeatIcon.vue?vue&type=template&id=6dae1746"
import script from "./AirplaneSeatIcon.vue?vue&type=script&lang=js"
export * from "./AirplaneSeatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports